/**
 * Предпросмотр счёта или акта внутри приложения.
 *
 * Один компонент на оба окна — создания счёта и просмотра готового. Раньше
 * разметка была скопирована в оба, и любая правка требовала помнить про
 * второе место.
 *
 * Три вещи, которые он делает и которых не делала копия:
 *
 *   1. Ограничивает стили документа своей обёрткой. Набор правил содержит
 *      `body`, `table`, `td, th` и `p`; подключённый как есть, он перекрашивал
 *      ВСЁ приложение за окном в Times New Roman с чёрными рамками у таблиц.
 *      Заметить это трудно: окно само закрывает собой испорченное.
 *   2. Надевает на содержимое класс `.doc` или `.doc-akt`. Без него акт
 *      показывался засечным шрифтом, хотя уходит клиенту рубленым: человек
 *      сверял на экране не то, что отправлял.
 *   3. Ужимает лист по ширине экрана — этим занят `FitToWidth`.
 */

import {
  DOCUMENT_PREVIEW_CLASS,
  documentPreviewStyles,
  renderDocumentBody,
  type DocumentModel,
} from '@otc/shared';
import { FitToWidth } from './FitToWidth.js';

/**
 * Ширина, на которую свёрстан документ.
 *
 * Ниже неё таблица платёжки и таблица позиций начинают ломаться: колонки
 * заданы долями процента, и при сжатии текст в них рассыпается по слогам.
 */
const NATURAL_WIDTH = 660;

export function DocumentPreview({ model }: { model: DocumentModel }) {
  return (
    <FitToWidth
      naturalWidth={NATURAL_WIDTH}
      className="mb-4 overflow-x-auto rounded-lg border bg-white p-4"
      style={{ borderColor: 'var(--otc-line)' }}
    >
      <style>{documentPreviewStyles()}</style>
      <div className={DOCUMENT_PREVIEW_CLASS}>
        <div
          className={model.kind === 'akt' ? 'doc-akt' : 'doc'}
          dangerouslySetInnerHTML={{ __html: renderDocumentBody(model) }}
        />
      </div>
    </FitToWidth>
  );
}
